import { FC, ReactNode } from 'react';

import { VideoCardDescription } from './VideoCardDescription';
import { VideoPlayer } from './VideoPlayer';

type Props = {
  PermissionStatus?: ReactNode;
  Title: ReactNode;

  createdAt: Date;
  displayName: string;
  photoUrl: string;

  video: {
    isFailed: boolean;
    isLoading: boolean;
    url: string;
    posterUrl: string;
    aspectRatio: string;
  };
};

export const VideoCard: FC<Props> = ({
  createdAt,
  displayName,
  photoUrl,
  PermissionStatus,
  Title,
  video,
}) => {
  const { isFailed, isLoading, url, posterUrl, aspectRatio } = video;

  return (
    <div className="flex flex-col sm:gap-y-4 gap-y-8">
      <VideoCardDescription
        createdAt={createdAt}
        displayName={displayName}
        photoUrl={photoUrl}
        PermissionStatus={PermissionStatus}
        Title={Title}
      />
      <VideoPlayer
        url={url}
        posterUrl={posterUrl}
        aspectRatio={aspectRatio}
        isFailed={isFailed}
        isLoading={isLoading}
      />
    </div>
  );
};
